import React, { useState, useEffect } from "react";
import { View, StyleSheet, Pressable, ScrollView } from "react-native";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { DownArrow } from "../../svgs/common";

const MoveActivityModal = ({
  visible,
  onClose,
  modules,
  currentModuleId,
  activityId,
  activityType,
  onMoveActivity,
}) => {
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [availableModules, setAvailableModules] = useState([]);

  useEffect(() => {
    // Filter out the current module from the list
    if (modules && modules.length > 0) {
      setAvailableModules(modules.filter((module) => module.id !== currentModuleId));
    }
  }, [modules, currentModuleId]);

  const handleModuleSelect = (moduleId) => {
    setSelectedModuleId(moduleId);
  };

  const handleMove = () => {
    if (selectedModuleId) {
      onMoveActivity(activityId, currentModuleId, selectedModuleId, activityType);
      onClose();
    }
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title="Move Activity"
      style={styles.modal}>
      <View style={styles.container}>
        <CustomText
          text="Select a destination module:"
          size="m"
          weight="bold"
          useTranslationText={false}
          style={styles.subtitle}
        />

        <ScrollView style={styles.moduleList}>
          {availableModules.length > 0 ? (
            availableModules.map((module) => (
              <Pressable
                key={module.id}
                style={[styles.moduleItem, selectedModuleId === module.id && styles.selectedModuleItem]}
                onPress={() => handleModuleSelect(module.id)}>
                <CustomText
                  text={module.title}
                  size="m"
                  useTranslationText={false}
                  weight={selectedModuleId === module.id ? "bold" : "regular"}
                />
                {selectedModuleId === module.id && <DownArrow fill="#3B82F6" width={20} height={20} />}
              </Pressable>
            ))
          ) : (
            <View style={styles.noModules}>
              <CustomText text="No other modules available" useTranslationText={false} style={styles.noModulesText} />
            </View>
          )}
        </ScrollView>

        <View style={styles.footer}>
          <CustomButton text="Cancel" styleType="secondaryOutline" onPress={onClose} style={styles.cancelButton} />
          <CustomButton text="Move" styleType="primary" onPress={handleMove} disabled={!selectedModuleId} />
        </View>
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modal: {
    width: 480,
    maxWidth: "90%",
    backgroundColor: "#FFFFFF",
    height: "80vh",
  },
  container: {
    flex: 1,
    padding: 16,
  },
  subtitle: {
    marginBottom: 16,
    color: "#374151",
  },
  moduleList: {
    marginBottom: 24,
  },
  moduleItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 8,
    marginBottom: 8,
  },
  selectedModuleItem: {
    borderColor: "#3B82F6",
    backgroundColor: "#EFF6FF",
  },
  noModules: {
    padding: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  noModulesText: {
    color: "#6B7280",
  },
  footer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 24,
  },
  cancelButton: {
    marginRight: 12,
  },
});

export default MoveActivityModal;
